(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      init() {
        if (this.ready || !this.isConnected) return;

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;

        this.ready = true;
        this.ac = new AbortController();
        const signal = this.ac.signal;

        this.index = 0;
        this.locked = false;
        this.holds = new Set();
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.effect = this.dataset.effect === 'fade' ? 'fade' : 'slide';
        this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.duration = parseInt(this.dataset.duration, 10) || 600;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced;

        const viewport = this.querySelector('[data-viewport]') || this;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1), { signal });
        if (next) next.addEventListener('click', () => this.step(1), { signal });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.go(i, i > this.index ? 1 : -1), { signal });
        });

        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowLeft') this.step(-1);
            if (e.key === 'ArrowRight') this.step(1);
          },
          { signal }
        );

        /* Swipe */
        viewport.addEventListener(
          'touchstart',
          (e) => {
            const t = e.changedTouches[0];
            this.tx = t.clientX;
            this.ty = t.clientY;
            this.hold('touch');
          },
          { signal, passive: true }
        );
        viewport.addEventListener(
          'touchend',
          (e) => {
            const t = e.changedTouches[0];
            const dx = t.clientX - this.tx;
            const dy = t.clientY - this.ty;
            this.release('touch');
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
          },
          { signal, passive: true }
        );
        viewport.addEventListener('touchcancel', () => this.release('touch'), { signal, passive: true });

        /* Pause rules for autoplay */
        this.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && this.hold('hover'), { signal });
        this.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && this.release('hover'), { signal });
        this.addEventListener('focusin', (e) => e.target.matches(':focus-visible') && this.hold('focus'), { signal });
        this.addEventListener('focusout', () => this.release('focus'), { signal });
        document.addEventListener(
          'visibilitychange',
          () => (document.hidden ? this.hold('hidden') : this.release('hidden')),
          { signal }
        );

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => (entry.isIntersecting ? this.release('offscreen') : this.hold('offscreen')),
            { threshold: 0.2 }
          );
          this.io.observe(this);
        }

        /* Theme editor support */
        this.addEventListener(
          'shopify:block:select',
          (e) => {
            const i = this.slides.indexOf(e.target.closest('[data-slide]'));
            this.hold('editor');
            if (i > -1) this.go(i, i > this.index ? 1 : -1, true);
          },
          { signal }
        );
        this.addEventListener('shopify:block:deselect', () => this.release('editor'), { signal });

        this.start();
      }

      applyRatio(slide) {
        const d = parseFloat(slide.dataset.ratioD);
        const t = parseFloat(slide.dataset.ratioT);
        const m = parseFloat(slide.dataset.ratioM);
        if (d > 0) this.style.setProperty('--hs-ratio-d', d);
        if (t > 0) this.style.setProperty('--hs-ratio-t', t);
        if (m > 0) this.style.setProperty('--hs-ratio-m', m);
      }

      teardown() {
        this.stop();
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        this.ready = false;
      }

      hold(key) {
        this.holds.add(key);
        this.stop();
      }

      release(key) {
        if (!this.holds.delete(key)) return;
        if (!this.holds.size) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.holds.size) return;
        this.timer = setTimeout(() => this.step(1), this.delay);
      }

      stop() {
        clearTimeout(this.timer);
      }

      step(dir) {
        const n = this.slides.length;
        this.go((this.index + dir + n) % n, dir);
      }

      go(next, dir, force) {
        if (next === this.index) return;
        if (this.locked && !force) return;

        this.locked = true;
        setTimeout(() => (this.locked = false), this.duration);

        const prev = this.slides[this.index];
        const incoming = this.slides[next];

        clearTimeout(incoming._t);
        incoming.classList.remove('is-leaving');

        if (this.effect === 'slide') {
          incoming.style.transition = 'none';
          incoming.style.setProperty('--o', dir);
          incoming.classList.add('is-active');
          void incoming.offsetWidth;
          incoming.style.transition = '';
          incoming.style.setProperty('--o', 0);
          prev.style.setProperty('--o', -dir);
        } else {
          incoming.classList.add('is-active');
        }

        incoming.inert = false;
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        prev.inert = true;
        clearTimeout(prev._t);
        prev._t = setTimeout(() => prev.classList.remove('is-leaving'), this.duration + 50);

        this.dots.forEach((dot, i) => {
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = next;
        this.applyRatio(incoming);
        this.start();
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
